<template>
  <div>
    <Modal v-model="replaceYmsOrderGoodsModal" width="900" :title="$t('key1006100')">
      <template v-if="step===1">
        <p class="flex align-items-center mb5">
          <span class="red-dot"></span>
          <span>{{ $t('key1006103') }}</span>
        </p>
        <Table :columns="tableColumns1" :data="tableData1" @on-selection-change="selectionChange"></Table>
      </template>
      <template v-else-if="step===2">
        <Table :columns="tableColumns2" :data="selectTableData"></Table>
      </template>
      <p class="crimsonRedColor font-size-13 mt10 mb10">{{ $t('key1006031') + configCharacters() + $t('key1006101')}}</p>
      <template #footer>
        <Button @click="replaceYmsOrderGoodsModal = false">{{ $t('key1000112') }}</Button>
        <Button type="primary" @click="confirmBtn" :loading="btnLoading">{{ step === 1 ? $t('key1002560') : $t('key1006102') }}</Button>
      </template>
    </Modal>
    <!--添加商品弹窗-->
    <addCommonProductModal
      ref="addCommonProduct"
      :apiUrl="apiUrl"
      :customStyle="true"
      :showOptionsBtn="false"
      systemType="distributor"
      :distributorShowFieldKeyList="['options', 'goodsInfo','myInventory', 'supplierAvailableNumber', 'ymsAvailableNumber', 'suggestPrice', 'weight', 'length', 'status']"
      @selectGoodsList="selectProduct">
    </addCommonProductModal>
  </div>
</template>

<script>
import aliasb03645cf6abd4d56a73b13687765a5d8 from '@/locale/i18nUtils.js';

import Mixin from '@/components/mixin/common_mixin';
import api from '@/api/';
import addCommonProductModal from "@/components/common/addCommonProductModal.vue";

export default {
  name: 'replaceYmsOrderGoodsModal',
  mixins: [Mixin],
  data() {
    let v = this;
    return {
      replaceYmsOrderGoodsModal: false,
      step: 1,
      tableColumns1: [
        {
          type: 'selection',
          width: 60,
          key: 'select',
          align: 'left'
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000239'),
          key: 'skuInfo',
          minWidth: 240,
          render(h, params) {
            return h('div', {class: 'flex mt5 mb5'}, [
              v.tableImg(h, params, 'pictureUrl'),
              h('div', {class: 'ml5'}, [
                h('div', {class: 'flex align-items-start mb5'}, [
                  h('p', aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000100')),
                  h('p', {
                    style: {
                      flex: 1
                    }
                  }, params.row.name),
                ]),
                h('div', {class: 'flex align-items-start mb5'}, [
                  h('p', 'SKU：'),
                  h('p', {
                    style: {
                      flex: 1
                    }
                  }, params.row.ymsSku)
                ]),
                h('div', {class: 'flex align-items-start mb5'}, [
                  h('p', aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000240')),
                  h('p', {
                    style: {
                      flex: 1
                    },
                    class: 'color-green'
                  }, params.row.specifications),
                ])
              ])
            ]);
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003803'),
          key: 'quantity'
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1006090'),
          key: 'number',
          render(h, params) {
            return h('div', [
              h('Input', {
                props: {
                  disabled: !v.goodsListClone[params.index].checked,
                  value: v.goodsListClone[params.index].changeQuantity
                },
                class: v.goodsListClone[params.index].changeQuantity > params.row.quantity ? 'ipt-error' : '',
                on: {
                  'on-blur'(event) {
                    if (isNaN(Number(event.target.value))) {
                      v.goodsListClone[params.index].changeQuantity = 1;
                      v.$nextTick(() => {
                        v.goodsListClone[params.index].changeQuantity = 0;
                      });
                    } else {
                      v.goodsListClone[params.index].changeQuantity = event.target.value;
                    }
                  }
                }
              }),
              v.goodsListClone[params.index].changeQuantity > params.row.quantity && h('p', {style: {color: '#ed4014'}}, aliasb03645cf6abd4d56a73b13687765a5d8.t('key1006091'))
            ]);
          }
        }
      ],
      tableColumns2: [
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1006092'),
          key: 'orderInfo',
          minWidth: 240,
          render(h, params) {
            return h('div', {class: 'flex mt5 mb5'}, [
              v.tableImg(h, params, 'pictureUrl'),
              h('div', {class: 'ml5'}, [
                h('div', {class: 'flex align-items-start mb5'}, [
                  h('p', aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000100')),
                  h('p', {
                    style: {
                      flex: 1
                    }
                  }, params.row.name),
                ]),
                h('div', {class: 'flex align-items-start mb5'}, [
                  h('p', 'SKU：'),
                  h('p', {
                    style: {
                      flex: 1
                    }
                  }, params.row.ymsSku)
                ]),
                h('div', {class: 'flex align-items-start mb5'}, [
                  h('p', aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000240')),
                  h('p', {
                    style: {
                      flex: 1
                    },
                    class: 'color-green'
                  }, params.row.specifications),
                ])
              ])
            ]);
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1006093'),
          key: 'replaceSkuInfo',
          minWidth: 240,
          render(h, params) {
            let spec = '';
            let title = '';
            let sku = '';
            let imgPath = null;
            if (params.row._replaceGoods) {
              let skuImgPath = params.row._replaceGoods._productInfo.primaryImage;
              let spuImgPath = params.row._replaceGoods._productInfo._spuInfo.primaryImage;
              imgPath = skuImgPath ? skuImgPath : spuImgPath;
              if (params.row._replaceGoods.productGoodsSpecifications) {
                spec = params.row._replaceGoods.productGoodsSpecifications.map(i => i.name + '：' + i.value).join('、');
              }
              title = params.row._replaceGoods.name;
              sku = params.row._replaceGoods.ymsSku;
            }
            let _hasGoods = h('div', {class: 'flex mt5 mb5'}, [
              v.tableImg(h, params, null, imgPath),
              h('div', {class: 'ml5'}, [
                h('div', {class: 'flex align-items-start mb5'}, [
                  h('p', aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000100')),
                  h('p', {
                    style: {
                      flex: 1
                    }
                  }, title),
                ]),
                h('div', {class: 'flex align-items-start mb5'}, [
                  h('p', 'SKU：'),
                  h('p', {
                    style: {
                      flex: 1
                    }
                  }, sku)
                ]),
                h('div', {class: 'flex align-items-start mb5'}, [
                  h('p', aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000240')),
                  h('p', {
                    style: {
                      flex: 1
                    },
                    class: 'color-green'
                  }, spec),
                ])
              ])]);
            let _btn = h('Button', {
              'on': {
                'click'() {
                  v.openAddProduct({
                    index: params.index
                  });
                }
              }
            }, aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001182'));
            if (params.row._replaceGoods) {
              return _hasGoods;
            } else {
              return _btn;
            }
          }
        }
      ],
      tableData1: [],
      goodsListClone: [],
      selectTableData: [],
      apiUrl: api.post_ymsDistributorProductInfo_queryYmsProductGoods,
      addProductIndex: 0,
      btnLoading: false,
      detailData: {}
    };
  },
  methods: {
    // 初始化数据
    initReplaceYmsOrderGoodsData(obj, goodsList) {
      this.detailData = obj;
      this.goodsListClone = [];
      this.step = 1;
      if (goodsList.length > 0) {
        goodsList.map((item) => {
          item.checked = false;
          item.changeQuantity = 0;
          item._replaceGoods = null;
        });
        this.tableData1 = goodsList;
        this.goodsListClone = JSON.parse(JSON.stringify(this.tableData1));
      } else {
        this.tableData1 = [];
      }
      this.replaceYmsOrderGoodsModal = true;
    },
    // 第一步：勾选需要更换的商品
    selectionChange(data) {
      let v = this;
      v.goodsListClone.forEach((j, index) => {
        let _check = data.some(i => i.ymsProductGoodsId === j.ymsProductGoodsId);
        v.$set(v.goodsListClone[index], 'checked', _check);
        if (!_check) {
          v.$set(v.goodsListClone[index], 'changeQuantity', 0);
        }
      });
      v.selectTableData = data;
    },
    // 第二步：选择商品
    openAddProduct({index}) {
      this.addProductIndex = index;
      this.$refs['addCommonProduct'].matchingGoodsType = 'single';
      this.$refs['addCommonProduct'].initFun();
    },
    // 选择商品之后，确认更换的商品信息
    selectProduct(data) {
      let v = this;
      if (data.ymsSku === v.selectTableData[v.addProductIndex].ymsSku) {
        v.$Message.info(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1006094'));
        return;
      }
      this.$set(v.selectTableData[v.addProductIndex], '_replaceGoods', data);
    },
    confirmBtn() {
      // 下一步
      let v = this;
      if (v.step === 1) {
        let _valid = false;
        if (v.goodsListClone.some(i => i.changeQuantity > i.quantity)) {
          v.$Message.info(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1006095'));
          return false;
        }

        if (v.selectTableData.length === 0) {
          v.$Message.info(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1006096'));
          return false;
        }
        v.goodsListClone.forEach(i => {
          if (i.checked && Number(i.changeQuantity) === 0) {
            _valid = true;
          }
        });
        if (_valid) {
          v.$Message.info(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1006097'));
          return false;
        }
        v.step = 2;
      }
      // 确认更换
      else if (v.step === 2) {
        let _valid = false;
        v.selectTableData.forEach(i => {
          if (!i._replaceGoods) {
            _valid = true;
          }
        });
        if (_valid) {
          v.$Message.info(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1006098'));
          return;
        }
        let _goodsList = JSON.parse(JSON.stringify(v.goodsListClone));
        let _checkData = JSON.parse(JSON.stringify(v.selectTableData));
        _goodsList.forEach(i => {
          i._quantity = i.quantity - i.changeQuantity;
        });
        _goodsList = _goodsList.filter(i => i._quantity > 0);
        _checkData.forEach(i => {
          v.goodsListClone.forEach(j => {
            if (i.ymsProductGoodsId === j.ymsProductGoodsId) {
              i._quantity = j.changeQuantity;
            }
          });
        });

        _goodsList.forEach(i => {
          _checkData.forEach(j => {
            if (i.ymsSku === j._replaceGoods.ymsSku) {
              i._quantity = Number(i._quantity) + Number(j._quantity);
              j._hasSku = true;
            }
          });
        });
        let goods = [..._goodsList.map(i => {
          return {
            ymsSku: i.ymsSku,
            /*originalSku: i.ymsSku,
            ymsProductGoodsId: i.ymsProductGoodsId,*/
            quantity: i._quantity
          };
        }), ..._checkData.filter(i => {
          return !i._hasSku;
        }).map(i => {
          return {
            ymsSku: i._replaceGoods.ymsSku,
            /* originalSku: i.ymsSku,
             ymsProductGoodsId: i._replaceGoods.ymsProductGoodsId,*/
            quantity: i._quantity
          };
        })];
        let params = {
          isHand: v.detailData.isHand,
          packageCode: v.detailData.packageCode,
          ymsPackageId: v.detailData.ymsPackageId,
          packageGoodsList: goods // 所有货品 包含替换商品和原商品
        };
        v.btnLoading = true;
        v.axios.post(api.post_ymsDistributorPackageInfo_replacePackageGoods, params, {loading: true, loadingText: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1006099')}).then(response => {
          v.btnLoading = false;
          if (response.data.code === 0) {
            v.$Message.success(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000155'));
            v.replaceYmsOrderGoodsModal = false;
            let data = response.data.datas;
            v.$emit('replaceYmsOrderGoodsSuccess', data);
          }
        });
      }
    }
  },
  components: {
    addCommonProductModal
  }
};
</script>

<style>
.ipt-error {
  border: 1px solid #ed4014;
}
</style>
<style scoped>
.table-close {
  position: absolute;
  top: 0;
  right: 0;
  font-size: 14px;
}

</style>